export default "__VITE_ASSET__6c5182f2__"